module.exports = __webpack_public_path__ + "img/sheshi.d934505f.png";